<template>
  <q-dialog v-model="openModal" persistent class="auction-item-page-bid">
    <q-card style="min-width: 800px">
      <q-card-section class="card-section">
        <div class="card-title">Auction item Details</div>
      </q-card-section>
      <q-separator />
      
      <q-card-section class="card-content">
        <div class="currency-details">
            <div class="currency">
              Currency: <span>{{ itemDetails.currency }}</span>
            </div>
            <div class="timer">
              Remianing Time: <span id="timer">{{ countDown }}</span>
            </div>
        </div>
        <div class="item-details">
          <div class="item-image">
            <img
              :src="itemDetails.product_img"
            />
          </div>
          <div class="item-name">
            {{ itemDetails.product_name }}
          </div>
        </div>
        <div class="bid-info">
          <div class="column">
            <p>Starting Bid: <span class="starting-bid">{{ Number(itemDetails.starting_bid).toLocaleString('en-US') }}</span></p>
          </div>
          <div class="column">
            <p>Buy Out: <span class="starting-bid">{{ Number(itemDetails.buy_out).toLocaleString('en-US') }}</span></p>
          </div>
        </div>
        <div class="bid-details">
          <div class="column" v-if="itemDetails.details">
            <div v-for="detail in itemDetails.details" :key="detail.id">
              <p v-if="detail.bid_amount && !detail.outbid_amount">{{ detail.bidder_name }} <span class="starting-bid">{{ Number(detail.bid_amount).toLocaleString('en-US') }}</span></p>
            </div>
          </div>
          <div class="column" v-if="itemDetails.details">
            <div v-for="detail in itemDetails.details" :key="detail.id">
              <p v-if="detail.outbid_amount">{{ detail.outbid_by }} <span class="starting-bid">{{ Number(detail.outbid_amount).toLocaleString('en-US') }}</span></p>
            </div>
          </div>
        </div>

        <div class="top-bidder" >
          <div class="bidder-name">
            {{ countDown === 'END BID' ? 'Winner: ' : 'Current Top Bidder: ' }}
            <b>
              {{ itemDetails.top_bidder ? itemDetails.top_bidder.bidder_name + '(' : 'No current Bid' }}
            </b>
          </div>
          <div class="bid-amount" v-if="itemDetails.top_bidder">
            {{ Number(itemDetails.top_bidder.bid_amount).toLocaleString('en-US') + ')' }}
          </div>
        </div>

        <div class="bidder">
          <div class="bidder-name" v-if="countDown !== 'END BID'">
            <q-select
              v-model="fields.bidder"
              :options="characters"
              option-value="ChaNum"
              option-label="ChaName"
              hint="Select Bidder"
              label="Select Bidder"
              map-options
              dark
              outlined
              class="select"
            />
          </div>
          <div class="bidder-amount" v-if="countDown !== 'END BID'">
            <q-input
              v-model="fields.bid_amount"
              hint="Bid Amount"
              placeholder="Bid Amount"
              dark
              outlined
            />
          </div>
          <div class="bidder-submit">
            <q-btn
              v-if="countDown !== 'END BID'"
              label="Submit"
              color="red"
              no-caps
              size="md"
              style="margin-top: 2px; margin-right: 8px;"
              @click="submitBid(false)"
            />
            <q-btn
              v-if="countDown !== 'END BID'"
              label="Buyout"
              color="green"
              no-caps
              size="md"
              style="margin-top: 2px; margin-right: 8px;"
              @click="submitBid(true)"
            />
            <q-btn
              v-if="isWinner && countDown === 'END BID'"
              label="Claim"
              color="green"
              no-caps
              size="md"
              style="margin-top: 2px; margin-right: 8px;"
              @click="claimItemLocal"
            />
          </div>
          
        </div>
        <div class="close-btn">
          <q-btn
            label="Leave Auction"
            class="leave"
            size="md"
            @click="openModal = false"
          />
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AuctionDetailsModal',
  data () {
    return {
      countDown: '',
      timer: null,
      fields: {
        bidder: null,
        bid_amount: null
      },
      openModal: false
    }
  },
  props: {
    itemDetails: {
      type: Object,
      require: true
    },
    open: {
      type: Boolean,
      require: true
    }
  },
  computed: {
    ...mapGetters({
      getServerTime: 'auction/getServerTime',
      characters: 'user/getCharacters',
      user: 'user/getUser'
    }),
    isWinner () {
      const { top_bidder, remarks } = this.itemDetails

      if (top_bidder && this.countDown === 'END BID' && !remarks) {
        return Number(top_bidder.is_winner) === 1 && this.user.UserID === top_bidder.user_id
      }

      return false
    }
  },
  watch: {
    itemDetails (val) {
      if (val) {
        this.startTimer()
      }
    },
    open (val) {
      this.openModal = val
    },
    openModal (val) {
      if (!val) {
        this.$emit('close')
        this.resetFields();
      }
    }
  },
	methods: {
		...mapActions({
      bidItem: 'auction/bidItem',
      claimItem: 'auction/claimItem'
		}),
    startTimer() {
      if (this.timer) clearInterval(this.timer)

      if (Number(this.itemDetails.is_buyout) === 1) {
        this.countDown = 'END BID'
        return
      }

      const countDownDate = new Date(this.itemDetails.expires_at).getTime();

      this.timer = setInterval(() => {
        const serverTime = new Date(this.getServerTime).getTime();

        const distance  = countDownDate - serverTime;

        var days = Math.floor(distance / (1000 * 60 * 60 * 24))
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        var seconds = Math.floor((distance % (1000 * 60)) / 1000)

        this.countDown = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";

        if (distance < 0) {
          clearInterval(this.timer);
          this.countDown = "END BID"
        }
      }, 1000)
    },
    async submitBid (isOutBid) {
      if (!this.itemDetails) return

      if (this.countDown === "END BID") {
        this.$q.notify({
          position: 'top-right',
          message: 'Auction Item is already Ended',
          type: 'negative'
        })

        return;
      }

      if (!this.fields.bidder) {
        this.$q.notify({
          position: 'top-right',
          message: 'Please Select Bidder First',
          type: 'negative'
        })

        return;
      }

      const { ChaOnline, ChaNum, ChaMoney } = this.fields.bidder
      const { starting_bid, top_bidder, id, outbid_amount } = this.itemDetails
      
      if (Number(ChaOnline) === 1) {
        this.$q.notify({
          position: 'top-right',
          message: 'Please Logout first ingame.',
          type: 'negative'
        })

        return;
      }

      if (this.fields.bid_amount > Number(ChaMoney) && !isOutBid) {
        this.$q.notify({
          position: 'top-right',
          message: 'You dont have enough money to bid',
          type: 'negative'
        })

        return
      }

      if (isOutBid) {
        if (Number(ChaMoney) < outbid_amount) {
          this.$q.notify({
            position: 'top-right',
            message: 'You dont have enough money to out bid',
            type: 'negative'
          })

          return
        }
      }

      // check if top bidder
      if (!top_bidder && !isOutBid) {
        if (Number(starting_bid) >= this.fields.bid_amount) {
          this.$q.notify({
            position: 'top-right',
            message: 'Bid amount must be more than starting bid',
            type: 'negative'
          })

          return
        }
      } else {
        if (Number(top_bidder.bid_amount) >= this.fields.bid_amount && !isOutBid) {
          this.$q.notify({
            position: 'top-right',
            message: 'Bid amount must be more than in top bidder',
            type: 'negative'
          })

          return
        }
      }

      this.$q.loading.show()

      const parameter = {
        auction_id: id,
        cha_num: ChaNum,
        bid_amount: this.fields.bid_amount ? this.fields.bid_amount : 0,
        outbid: isOutBid
      }

      await this.recaptchaLoad('biditem')

      await this.bidItem(parameter)
        .then(async response => {
          await this.recaptchaLoad('biditem')

          this.$emit('success-request')

          this.$emit('close')

          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive'
          })

          this.resetFields()
          
          this.$q.loading.hide()
        })
        .catch(error => {
          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative'
          })

          this.$q.loading.hide()
        })
    },
    async claimItemLocal () {
      if (!this.isWinner) return
      
      const { id } = this.itemDetails

      const parameter = {
        auction_id: id
      }

      this.$q.loading.show();

      await this.recaptchaLoad('claimitem')

      await this.claimItem(parameter)
        .then(async response => {
          await this.recaptchaLoad('claimitem')

          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive'
          })
          
          this.$q.loading.hide()
        })
        .catch(error => {
          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative'
          })

          this.$q.loading.hide()
        })
    },
    resetFields () {
      this.fields = {
        bidder: null,
        bid_amount: null
      }
    }
  }
}
</script>
<style lang="scss">
.auction-item-page-bid {
  margin-top: 8px;

  .card-title {
    font-size: 16px;
    font-weight: 700;
  }

  .card-section {
    background-color: $backgroundHeader;
    color: white;
  }

  .card-content {
    background-color: $background;

    .currency-details {
      font-size: 14px;
      font-weight: 700;
      color: white;
      display: flex;
      justify-content: flex-end;

      .currency {
        span {
          color: orange;
        }
      }

      .timer {
        margin-left: auto; 
        margin-right: 0;

        span {
          color: red;
        }
      }
    }

    .item-details {
      margin-top: 8px;
      background-color: $background;
      display: flex;

      .item-image {
        float: left;
        width: 60px;
        height: 60px;
      }

      .item-name {
        float: left;
        margin-top: 12px;
        color: white;
        font-weight: 700;
      }
    }

    .bid-info {
      padding: 0px;
      display: flex;

      .column {
        float: left;
        width: 50%;
        text-align: center;
        color: white;
        border: solid 1px;

        p {
          margin: 0;
          padding: 8px;
        }

        .starting-bid {
          white-space: nowrap;
          color: greenyellow;
          font-size: 16px;
          font-weight: 700;
        }
      }
    }

    .bid-details {
      padding: 0px;
      display: flex;

      .column {
        float: left;
        width: 50%;
        text-align: left;
        color: white;
        border: solid 1px;

        p {
          margin: 0;
          padding: 8px;
        }

        .starting-bid {
          white-space: nowrap;
          color: white;
          font-size: 16px;
          font-weight: 700;
        }
      }
    }

    .top-bidder {
      margin-top: 8px;
      color: white;
      display: flex;
      background-color: $backgroundHeader;
      padding: 8px;

      .bidder-name {
        float: left;
      }

      .bid-amount {
        float: left;
        color: white;
        font-weight: 700;
      }
    }

    .bidder {
      margin-top: 8px;
      color: white;
      display: flex;
      gap: 16px;

      .bidder-name {
        color: white;
        width: 200px;
      }

      .bidder-amount {
        color: white;
        width: 200px;
      }
    }

    .close-btn {
      margin-top: 16px;
      margin-left: 42%;

      .q-field__control:before {
        border-color: black;
      }
      
      .leave {
        background-color: #FFC108;
      }
    }
  }
}
</style>